"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Pin = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M10.698.21a.72.72 0 10-1.019 1.02l.51.509-4.89 3.26-.204-.204a1.44 1.44 0 10-2.037 2.038L5.095 8.87.002 16.002l7.13-5.094 2.038 2.038a1.44 1.44 0 102.037-2.038l-.204-.204 3.26-4.89.51.51a.72.72 0 101.018-1.02L10.698.212z",
  fill: "#ACB3BE"
}));

var _default = Pin;
exports.default = _default;